
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import Overview from './Overview/Overview'
import NavigationView from './Navigation/NavigationView'
import NavigationDesignerView from './Designer/NavigationDesignerView'
import SalesView from './Sales/SalesView'
import CLILogs from './Reports/cli/CLILogs'
import OrderView from './Order/OrderView'
import AttendanceView from './Staff/Attendance/AttendanceView';
import RotaView from './Staff/Rota/RotaView';
import HolidaysView from './Staff/Holidays/HolidaysView'
import DailySummaryReport from './Reports/dailyReports/dailySummaryReport/DailySummaryReport';
import ItemSnoozeView from './Snooze/ItemSnooze/ItemSnoozeView'
import PropertySnoozeView from './Snooze/PropertySnooze/PropertySnoozeView'
import DriverSalesReport from './Reports/dailyReports/driverSalesReport/DriverSalesReport';
import NotificationsView from './Notifications/NotificationsView';
import NavigationDialogueFacade from './Navigation/NaivationDialogueFacade'
import MenuSnooze from './Snooze/MenuSnooze/MenuSnooze'

const navigationButtonsIds = require('./Navigation/navigationButtonsIds');
const stateManager = require('../utils/state/stateManager');
const translator = require('../utils/translator/translator');

class NavigationPageFacade extends Component 
{
    render()
    {
        let component = null;

        var navigationPagePayload = stateManager.getStore().getState().navigationPage;

        if (navigationPagePayload == null)
            component = <NavigationView/>
        else
        {

            if(navigationButtonsIds.overview == this.props.params.id)
                component = <Overview/>

            if(navigationButtonsIds.salesHistory == this.props.params.id)
                component = <SalesView filterCriteria={this.props.params.filterCriteria} title={translator.getLabel("salesHistory")}/>

            if(navigationButtonsIds.outstanding == this.props.params.id)
                component = <SalesView filterCriteria={this.props.params.filterCriteria} title={translator.getLabel("outstanding_sales")}/>

            if (navigationButtonsIds.dailySummary === this.props.params.id)
                component =  <DailySummaryReport filterCriteria={this.props.params.filterCriteria}/>

            if (navigationButtonsIds.dailySummary === this.props.params.id)
                return <DailySummaryReport filterCriteria={this.props.params.filterCriteria} title={translator.getLabel("daily_summary_report")} />

            if (navigationButtonsIds.driverSales === this.props.params.id)
                return <DriverSalesReport filterCriteria={this.props.params.filterCriteria} title={translator.getLabel("driver_sales_report")} />

            if(navigationButtonsIds.callLogs == this.props.params.id)
                component =  <CLILogs/>

            if(navigationButtonsIds.navigationDesigner == this.props.params.id)
                component =  <NavigationDesignerView/>

            if(navigationButtonsIds.order == this.props.params.id)
                component =  <OrderView/>

            if(navigationButtonsIds.itemSnooze == this.props.params.id)
                return <ItemSnoozeView title={translator.getLabel("itemSnooze")}/>

            if(navigationButtonsIds.attendance == this.props.params.id)
                component =  <AttendanceView title={translator.getLabel("attendance")}/>

            if(navigationButtonsIds.rota == this.props.params.id)
                component =  <RotaView title={translator.getLabel("rota")}/>

            if(navigationButtonsIds.propertySnooze == this.props.params.id)
                component =  <PropertySnoozeView title={translator.getLabel("propertySnooze")}/>
           
            if(navigationButtonsIds.notifications == this.props.params.id)
                component =  <NotificationsView selectedNotificationId = {this.props.params.selectedNotificationId}/>

            if(navigationButtonsIds.holidays == this.props.params.id)
                component =  <HolidaysView title={translator.getLabel("holidays")}/>

            if (navigationButtonsIds.menuSnooze == this.props.params.id)
                component = <MenuSnooze title={translator.getLabel("menuSnooze")} />
            
        }

        return <Fragment>
                    {component}
                    {this.renderNavigationDialogue()}
            </Fragment>
    }

    renderNavigationDialogue()
    {
        if (this.props.navigationDialogue == null)
            return null;

        return <NavigationDialogueFacade params={this.props.navigationDialogue}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                navigationDialogue: state.navigationDialogue,
           }
}

export default connect(mapStateToProps)(NavigationPageFacade)